import React, {Component} from "react";
import { connect } from "react-redux";
import { Table } from 'reactstrap';
import { createFilter } from 'react-search-input';
import { GetWorkorderList, GetClosedWorkorderList } from "../../../../../action/workorderAction";
import { GetUserList } from "../../../../../action/Administration/administrationAction";
import LoadingIndicator from '../../../Common/LoadingIndicator';

var status_values = [], data_list = [], KEYS_TO_FILTERS = [] ;
let WorkOrderList = [], WorkOrderClosedList = [];

class WOUserProgress extends Component{
    componentWillMount(){
        if(this.props.WorkOrderList !== null && this.props.WorkOrderList !== undefined){
            WorkOrderList = this.props.WorkOrderList;
            if(this.props.WorkOrderClosedList !== null && this.props.WorkOrderClosedList !== undefined){
                WorkOrderClosedList = this.props.WorkOrderClosedList;
                this.setState({isloading: false});   
            }
            else{
                this.props.GetClosedWorkorderList().then(() => {
                WorkOrderClosedList = this.props.getWorkorderList.ClosedWorkOrderList;
                this.setState({isloading: false});
                });
            }
                    
        }

        else{
        this.props.GetWorkorderList().then(() => {
            WorkOrderList = this.props.getWorkorderList.WorkOrderList;
            this.props.GetClosedWorkorderList().then(() => {
                WorkOrderClosedList = this.props.getWorkorderList.ClosedWorkOrderList;
                this.setState({isloading: false});
            })
        });
        }

        this.props.GetUserList();
    }

    constructor(props){
        super(props);
        this.state = {
            isloading: true,
            TimeFilterValue: "1",
            searchTerm: "",
            filterkey: false,
            isSorted: false,
            IsDefaultSort: true,
            sort: {
                column: null,
                direction: [
                    { name: 'Assigned To', direction: 'asc', onclick: true },
                ]
            },
        };
        this.searchUpdated = this.searchUpdated.bind(this);
        this.OnSort = this.OnSort.bind(this);
        this.OnTimeFilterChange = this.OnTimeFilterChange.bind(this);
        this.formTableData = this.formTableData.bind(this);
    }
  
    searchUpdated(term) {
        this.setState({ searchTerm: this.refs.wo_search_value.value })
    }

    OnSort(values) {
        if (values !== undefined && values !== null && values !== "--") {
            const sorted_data = values.sort((a, b) => {
                let nameA, nameB;
                nameA = a.orderId;
                nameB = b.orderId;
                return (nameA - nameB);
            });
            return sorted_data;
        }
    }

    onSortColumn = (column) => (e) => {
        this.setState({isSorted: true, IsDefaultSort:false});
        var SortData = this.state.sort.direction;
        var array;
        var selected = SortData.filter(a => a.name === column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = data_list;
        var notequals = 0;
        if (data_from_state != null) {
            const sortedData = data_from_state.sort((a, b) => {
                let nameA = (column === "Assigned To") ? a[column].toLowerCase() : a[column];
                let nameB = (column === "Assigned To") ? b[column].toLowerCase() : b[column];
                
                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA === nameB) {
                    return 0;
                }
                return 0;
            });

            if (selected[0].direction === 'asc' && notequals === 1) {
                sortedData.reverse();
            }

            if (selected[0].name === "Assigned To") {
                SortData[0].direction = direction;
                array = this.state.sort.direction;
                array.map(x => (x.name !== "Assigned To") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }else{
                var index = SortData.findIndex(e => e.name === column);
                SortData[index].direction = direction;
                array = this.state.sort.direction;
                array.map(x => (x.name !== column) ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            
            data_list = sortedData;
            this.setState({
                sort: { column, direction: SortData }
            });
        }
    }

    OnTimeFilterChange(){
        var selectedOption = this.refs.time_filter_in_Select_input.options.selectedIndex;
        var lFilterId = this.refs.time_filter_in_Select_input.options[selectedOption].id;
        this.setState({TimeFilterValue : lFilterId, isSorted:false});
    }

    getWeek() {
        var l_today = new Date();
        let dayOfWeek = l_today.getDay(); //0-6
        let numDay = l_today.getDate();

        let start = new Date(l_today); 
        start.setDate(numDay - dayOfWeek);
        start.setHours(0, 0, 0, 0);


        let end = new Date(l_today); 
        end.setDate(numDay + (7 - dayOfWeek));
        end.setHours(0, 0, 0, 0);

        return [start, end];
    };

    formTableData(filterId) {
        var lWorkOrders = [];
        if(WorkOrderList !== null && WorkOrderList !== undefined){
            WorkOrderList.forEach(el => {
                lWorkOrders.push(el);
            })
         };
         if(WorkOrderClosedList !== null && WorkOrderClosedList !== undefined){
            WorkOrderClosedList.forEach(el => {
                 lWorkOrders.push(el);
             })
         };
        var lTechnicians = this.props.getUserList;
        var selectedWorkOrders,rowData, assignedStatus=[];
        var current = new Date();     // get current date 
        if(lWorkOrders !== undefined && lWorkOrders !== null && lWorkOrders.length > 0 && !this.state.isloading){
            if(!this.state.isSorted){
                if(filterId === "1"){ // filter based on today 
                    current.setHours(0,0,0,0);  
                    selectedWorkOrders = lWorkOrders.filter(el =>new Date(el.dueDate).setHours(0,0,0,0) === Number(current));
                }
                if(filterId === "2"){ // filter based on this week    
                    var date = this.getWeek();
                    selectedWorkOrders = lWorkOrders.filter(el => new Date(el.dueDate).setHours(0, 0, 0, 0) >= Number(date[0]) && new Date(el.dueDate).setHours(0, 0, 0, 0) <= Number(date[1]));
                }
                if(filterId === "3"){ // filter based on this month
                    var monthstart = new Date(current.getFullYear(), current.getMonth() ,1).setHours(0,0,0,0);
                    var montheend = new Date(current.getFullYear(), current.getMonth()+1, 0).setHours(0,0,0,0);
                    selectedWorkOrders = lWorkOrders.filter(el => new Date(el.dueDate).setHours(0,0,0,0) >= monthstart && new Date(el.dueDate).setHours(0,0,0,0) <= montheend);
                }
                if(filterId === "4"){ //filter based on this year
                    selectedWorkOrders = lWorkOrders.filter(x => new Date(x.dueDate).getFullYear() === new Date().getFullYear());
                }
                if(selectedWorkOrders.length > 0 ){
                    var assignedWO = [...new Set(selectedWorkOrders.map(el => el.assignedUserID))]; //unique user id 
                    var unassginedWO = [];
                    assignedWO.forEach(ele => { // filtering unassigned user id
                        if(!lTechnicians.filter(e => e.userID === ele).length > 0 ){
                            unassginedWO.push(ele);
                    }})
                    assignedWO.forEach(ele => { // forming scheduled wo list with assigned user  
                        var lineitem={};
                        let selectedTechnician = (ele !== 0) ? lTechnicians.filter(e => e.userID === ele).length > 0 ? lTechnicians.filter(e => e.userID === ele)[0].firstName + ' ' + lTechnicians.filter(e => e.userID === ele)[0].lastName : 'Unassigned':'Unassigned'; //find assignee name
                        lineitem['Assigned To'] = selectedTechnician;
                        if(selectedTechnician!=="Unassigned"){     
                            var selectedData = selectedWorkOrders.filter(el => el.assignedUserID === ele)                    
                            status_values.forEach((item,index) =>{
                                let totalCount = selectedData.filter(el => el.status === item.key);
                                lineitem[item.value] = totalCount.length
                            })
                            assignedStatus.push(lineitem);
                        }
                    })
                    if(unassginedWO.length > 0){ // forming scheduled wo list with unassigned user
                        var lineitem = {};
                        lineitem['Assigned To'] = 'Unassigned';
                        var selectedData = selectedWorkOrders.filter(el => unassginedWO.includes(el.assignedUserID))                    
                        status_values.forEach((item,index) =>{
                            let totalCount = selectedData.filter(el => el.status === item.key);
                            lineitem[item.value] = totalCount.length
                        })
                        assignedStatus.push(lineitem);
                    }
                    data_list = assignedStatus;
                }
                //default sorting
                if(this.state.IsDefaultSort){
                    if (assignedStatus.length > 0) {
                        const sortedData = assignedStatus.sort((a, b) => {
                            let nameA, nameB;
                            nameA = a["Assigned To"].toLowerCase();
                            nameB = b["Assigned To"].toLowerCase();
            
                            if (nameA < nameB) {
                                return -1;
                            }
                            if (nameA > nameB) {
                                return 1;
                            }
                            if (nameA === nameB) {
                                return 0;
                            }
                            return 0;
                        });
                        assignedStatus = sortedData;
                    }
                } else{
                    if(this.state.sort.direction.length > 1){   //sorting
                        let sortColumn = this.state.sort.direction.filter(el => el.onclick === true);
                        if(assignedStatus.length > 1 && sortColumn.length > 0){
                            let Column = sortColumn[0].name;
                            let Direction = sortColumn[0].direction;
                            const sortedData = assignedStatus.sort((a, b) => {
                                let nameA = (Column === "Assigned To") ? a[Column].toLowerCase() : a[Column];
                                let nameB = (Column === "Assigned To") ? b[Column].toLowerCase() : b[Column];
                
                                if (nameA < nameB) {
                                    return -1;
                                }
                                if (nameA > nameB) {
                                    return 1;
                                }
                                if (nameA === nameB) {
                                    return 0;
                                }
                                return 0;
                            });
                            assignedStatus = (Direction === 'desc') ? sortedData.reverse() : sortedData;
                        }
                    }
                }
            }else{
                assignedStatus = data_list;
            }
            if(assignedStatus.length > 0 ){  // table row data
                let FilteredData = assignedStatus.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
                rowData = FilteredData.length ? FilteredData.map(el => {
                    var values = Object.values(el);
                    return <tr>
                            {values.map(e => <td>{e}</td>)}
                           </tr>
                }) :  <tr><td colspan={status_values.length + 1}>No Records Found</td></tr>
            }else{
                rowData =  <tr><td colspan={status_values.length + 1}>No Records Found</td></tr>
            }
        return rowData;
        }
        else if(!this.state.isloading){
            return <tr><td colspan={status_values.length + 1}>No Records Found</td></tr>
        }
        else{
            return <tr><td colSpan="4" style={{textAlign: 'center'}}><LoadingIndicator/></td></tr>
        }
    }

    render(){
        let label = this.props.getLabels;
        let preferredfields = this.props.getWorkorderPreferences;
        let time_Filters_in_Select_input = [], tableHeader, tableData, direction=[];

        var assignedto = preferredfields !== undefined && preferredfields !== "" ? preferredfields.filter(x => x.field === "Assigned To" && x.display === true) : '';
        var status = (preferredfields !== "" && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Status" && x.display === true) : "";
        var Status = (label['WorkOrders.Status.Text'] !== undefined) ? label['WorkOrders.Status.Text'].split(',') : "";
        if(status.length > 0){
            if(status[0].value.length > 0){ //table header data
                status_values = this.OnSort(status[0].value);
                tableHeader = <tr>
                                <th className="wo_cursor" onClick={this.onSortColumn('Assigned To')}>{assignedto.length > 0 ? assignedto[0].fieldLabel : "Assigned To"}<span className={(this.state.sort.direction[0] !== undefined && this.state.sort.direction[0].name === "Assigned To") ?
                                    (this.state.sort.direction[0].onclick) ? (this.state.sort.direction[0].direction === "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                        : (this.state.sort.direction[0].direction === "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                                </span></th>
                                {status_values.map(el => (<th className="wo_cursor" onClick={this.onSortColumn(el.value)}>{el.value}<span className={(this.state.sort.direction[1] !== undefined && this.state.sort.direction.filter(e => e.name === el.value)[0].name === el.value) ?
                                    (this.state.sort.direction.filter(e => e.name === el.value)[0].onclick) ? (this.state.sort.direction.filter(e => e.name === el.value)[0].direction === "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                        : (this.state.sort.direction.filter(e => e.name === el.value)[0].direction === "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                                </span></th>))}
                              </tr>
            }
            else{
                status_values = Status;
                tableHeader = <tr>
                                <th  className="wo_cursor" onClick={this.onSortColumn('Assigned To')}>{assignedto.length > 0 ? assignedto[0].fieldLabel : "Assigned To"}<span className={(this.state.sort.direction[0] !== undefined && this.state.sort.direction[0].name === "Assigned To") ?
                                    (this.state.sort.direction[0].onclick) ? (this.state.sort.direction[0].direction === "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                        : (this.state.sort.direction[0].direction === "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                                </span></th>
                                {status_values.map(el => (<th className="wo_cursor" onClick={this.onSortColumn(el.value)}>{label['WorkOrders.Status.' + el + '.Text']}<span className={(this.state.sort.direction[1] !== undefined && this.state.sort.direction.filter(e => e.name === el.value)[0].name === el.value) ?
                                    (this.state.sort.direction.filter(e => e.name === el.value)[0].onclick) ? (this.state.sort.direction.filter(e => e.name === el.value)[0].direction === "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                        : (this.state.sort.direction.filter(e => e.name === el.value)[0].direction === "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                                </span></th>))}
                              </tr>
            }
        }
    
        if(status_values.length > 0 && !this.state.filterkey){ //search filter list, sort option state
            var values = status_values.map(el => el.value);
            values[values.length] = 'Assigned To'
            KEYS_TO_FILTERS = values;
            direction[0] = this.state.sort.direction[0];
            status_values.map(el =>(direction.push({name:el.value,direction:'desc', onclick: false})))
            this.setState({filterkey: true, sort:{column:null,direction:direction}});
        }

        tableData = this.formTableData(this.state.TimeFilterValue);

        if(label['WorkOrderReports.TimeRange.Text'] !== undefined){ //filter options
            var filters = label['WorkOrderReports.TimeRange.Text'].split(',');
            time_Filters_in_Select_input = filters.map(el => (
                <option id={el} value={el}>{label['WorkOrderReports.TimeRange.'+el+'.Text']}</option>
            ))
        }

        return (
            <div className="main_container box_border">
                <label className={this.props.ForEquipment ? "workOrderlabel" : ""} style={{ fontFamily: 'lato', fontSize: '15px', fontWeight: 'bold', color: 'black' }}>Work Orders Assigned To by Status</label><br />
                <div className="row row_padding" style={{marginTop: "10px"}}>
                    <div className="col-md-12">
                    <label style={{ fontFamily: 'lato', fontSize: '13px', fontWeight: 'bold', color: 'black' }}>{label['WorkOrderDetails.SheduledDate.Text'] !== undefined ? label['WorkOrderDetails.SheduledDate.Text']+":" : "Scheduled Date:"}</label>
                        <select ref='time_filter_in_Select_input' style={{ marginLeft: '5px' }} className="pmminimal pm-dropdown" value={this.state.TimeFilterValue} onChange={this.OnTimeFilterChange}>
                            {time_Filters_in_Select_input}
                        </select>
                        <span className="pm_outersearchbox" style={{ float: 'right' }}>
                            <input type="text" id="kpi_assignedby_status_search" className="pm_searchbox" style={{ paddingLeft: '10px', marginTop: '3px' }} placeholder="Enter Value..." onChange={this.searchUpdated} ref='wo_search_value' />
                        </span>
                        <label style={{ fontFamily: 'lato', fontSize: '13px', fontWeight: 'bold', color: 'black', float: 'right', marginTop: '3px' }}>{label !== undefined ? label['PreventativeMaintenance.Search.Text'] : "Search:"}</label>
                    </div>
                </div>
                
                {(tableHeader !== undefined) ? <div className="table_container table_border table-vertical-scrollbar" style={{marginTop:'10px'}}>
                     <Table striped responsive className="Custom_table nowrap" id="kpi_assignedby_status_table">
                        <tbody  className="cell_container cell_align">
                            {tableHeader}
                            {tableData}        
                        </tbody>
                    </Table> 
                </div> :  "No data to display"} 
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getWorkorderPreferences: state.authService.workorder_user_preferencedetails,
        getWorkorderList: state.WorkorderRootReducer,
        getUserList: state.InstallationsRootReducer.UserLists
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetWorkorderList: () => dispatch(GetWorkorderList()),
        GetClosedWorkorderList: () => dispatch(GetClosedWorkorderList()),
        GetUserList: () => dispatch(GetUserList())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WOUserProgress);